// Auto-generated: Etsy CSV import + eBay products
// Last updated: 2026-05-01T05:11:43.233Z
// Etsy: 113 products | eBay: 171 products
// Re-import Etsy: node scripts/import-etsy-csv.js etsy-listings.csv
// Re-import eBay: node scripts/import-ebay-csv.js /path/to/ebay-listings.csv

const products = [
  {
    "name": "Modern Black Crystal Semi Flush Mount Light, 9 Inch Round Chandelier for Hallway Entryway",
    "price": 144.99,
    "image": "https://i.etsystatic.com/64439944/r/il/8eb866/7845044812/il_fullxfull.7845044812_j2xo.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern 7-Ring Geometric LED Ceiling Light – Dimmable Black Flush Mount Fixture (3000K–6500K)",
    "price": 299.99,
    "image": "https://i.etsystatic.com/64439944/r/il/90d9bf/7989181989/il_fullxfull.7989181989_64uo.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Double Arc LED Chandelier: Dimmable Aluminum Pendant Light",
    "price": 399.99,
    "image": "https://i.etsystatic.com/64439944/r/il/11f19f/7989139935/il_fullxfull.7989139935_41k2.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Rustic Black Farmhouse Lantern Sconce with Seeded Glass – 12 Exterior Wall Light",
    "price": 249.99,
    "image": "https://i.etsystatic.com/64439944/r/il/4f5270/7989119005/il_fullxfull.7989119005_qw4l.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Gold LED Chandelier with Acrylic Shades, Adjustable Height, 3-Color Light",
    "price": 349.99,
    "image": "https://i.etsystatic.com/64439944/r/il/cb1ad0/7941134830/il_fullxfull.7941134830_ei7q.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Boho Twine Cage Chandelier Fan with Light, 20 Inch Rattan Fandelier (Remote App Control)",
    "price": 249.99,
    "image": "https://i.etsystatic.com/64439944/r/il/06ee23/7878166158/il_fullxfull.7878166158_cy4d.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black 2-Ring LED Chandelier Pendant Light with Spotlight – Dimmable 20 Inch Dining Fixture",
    "price": 229.99,
    "image": "https://i.etsystatic.com/64439944/r/il/600109/7936742258/il_fullxfull.7936742258_qzro.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black 3-Ring LED Island Chandelier, Adjustable Pendant Light Fixture",
    "price": 219.99,
    "image": "https://i.etsystatic.com/64439944/r/il/c53156/7984668707/il_fullxfull.7984668707_s5qf.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Square Ring LED Chandelier, Black Geometric Ceiling Light, Adjustable Pendant Fixture",
    "price": 259.99,
    "image": "https://i.etsystatic.com/64439944/r/il/af0553/7936674452/il_fullxfull.7936674452_trg1.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Linear LED Chandelier: Black Pendant Light, Adjustable Height, Remote Control (3000K-6000K)",
    "price": 229.99,
    "image": "https://i.etsystatic.com/64439944/r/il/82323a/7936631824/il_fullxfull.7936631824_p45e.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal Swirl Chandelier: Silver Raindrop Pendant Light Fixture",
    "price": 349.99,
    "image": "https://i.etsystatic.com/64439944/r/il/d14160/7982846323/il_fullxfull.7982846323_m72d.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Wave LED Chandelier: Black Dimmable Pendant Light, Adjustable Hanging Ceiling Fixture",
    "price": 229.99,
    "image": "https://i.etsystatic.com/64439944/r/il/123752/7982820335/il_fullxfull.7982820335_s088.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black 4-Head LED Track Lighting Fixture: Rotatable, Dimmable, App/Voice Control",
    "price": 179.99,
    "image": "https://i.etsystatic.com/64439944/r/il/de1b98/7934850732/il_fullxfull.7934850732_j1cm.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Saturn Ring Pendant Light: Black Rotatable LED Fixture (3000K-6000K)",
    "price": 154.99,
    "image": "https://i.etsystatic.com/64439944/r/il/24c77a/7978960949/il_fullxfull.7978960949_lkrf.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Gold Linear Chandelier Pendant Light, Nordic Style LED Fixture",
    "price": 289.99,
    "image": "https://i.etsystatic.com/64439944/r/il/94436d/7928292092/il_fullxfull.7928292092_7b47.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Rustic Caged Square Flush Mount Ceiling Fan with Light – Industrial Farmhouse Design",
    "price": 319.99,
    "image": "https://i.etsystatic.com/64439944/r/il/dfbe0e/7975101617/il_fullxfull.7975101617_ggjc.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "6-Light Black Track Lighting Ceiling Fixture Modern Adjustable GU10 Spotlight Kit",
    "price": 269.99,
    "image": "https://i.etsystatic.com/64439944/r/il/1d3869/7947845041/il_fullxfull.7947845041_mn5a.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Gold Crystal Chandelier: 9-Light LED Pendant Light for Foyer Staircase",
    "price": 569.99,
    "image": "https://i.etsystatic.com/64439944/r/il/9b09a2/7947834367/il_fullxfull.7947834367_f0vj.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern LED Chandelier: 39 Inch Black Dimmable Pendant Light Fixture",
    "price": 369.99,
    "image": "https://i.etsystatic.com/64439944/r/il/ff6550/7899853150/il_fullxfull.7899853150_j2mf.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Gold 4-Light LED Track Lighting Fixture, Dimmable Ceiling Spotlight (Remote Included)",
    "price": 339.99,
    "image": "https://i.etsystatic.com/64439944/r/il/7ea4bf/7899835614/il_fullxfull.7899835614_6r2m.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern 3-Ring LED Chandelier: Dimmable Black Pendant Light, Adjustable Contemporary Fixture",
    "price": 369.99,
    "image": "https://i.etsystatic.com/64439944/r/il/14504e/7899816920/il_fullxfull.7899816920_eun6.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "4FT Modern Aluminum LED Pendant Light – Dimmable Hanging Ceiling Fixture with Remote",
    "price": 229.99,
    "image": "https://i.etsystatic.com/64439944/r/il/5dcd9d/7899806726/il_fullxfull.7899806726_3191.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal LED Chandelier: Three Ring Pendant Light, Warm White Acrylic Fixture",
    "price": 269.99,
    "image": "https://i.etsystatic.com/64439944/r/il/12a6c5/7947731319/il_fullxfull.7947731319_mjc0.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Sputnik Chandelier: Black Gold 12-Light Starburst Ceiling Fixture (33 Inch)",
    "price": 269.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f2ef2f/7947713867/il_fullxfull.7947713867_eiqb.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Linear LED Ceiling Light, 39.3 Inch Dimmable Flush Mount Lamp with Spotlights",
    "price": 249.99,
    "image": "https://i.etsystatic.com/64439944/r/il/6d70c3/7947694985/il_fullxfull.7947694985_69pb.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Mid-Century Modern Gold Semi Flush Mount Ceiling Light, White Glass Shade Lamp",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/ea852f/7899720476/il_fullxfull.7899720476_ri8i.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal Chandelier: 15.7 Inch 2-Ring Semi Flush Mount Ceiling Light",
    "price": 219.99,
    "image": "https://i.etsystatic.com/64439944/r/il/deb7b3/7947658675/il_fullxfull.7947658675_9i3q.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Gold Crystal Chandelier, 24 Inch Round 5 Tier Raindrop Ceiling Light Fixture",
    "price": 449.99,
    "image": "https://i.etsystatic.com/64439944/r/il/bf76f5/7939462695/il_fullxfull.7939462695_kc37.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "White Crystal Flush Mount Ceiling Fan with Light, 6-Speed Remote Control",
    "price": 289.99,
    "image": "https://i.etsystatic.com/64439944/r/il/6364b0/7891483278/il_fullxfull.7891483278_9pyq.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Bladeless Ceiling Fan with Light, White Flush Mount, Dimmable LED, Remote/App Control",
    "price": 289.99,
    "image": "https://i.etsystatic.com/64439944/r/il/b15e54/7939412139/il_fullxfull.7939412139_jtja.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Flush Mount Ceiling Fan with Light, 20-Inch Black Dimmable LED, Remote App Control",
    "price": 289.99,
    "image": "https://i.etsystatic.com/64439944/r/il/5fbd76/7891419488/il_fullxfull.7891419488_g4w0.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Bladeless Ceiling Fan with Light, Flush Mount LED Fandelier, Remote App Control",
    "price": 229.99,
    "image": "https://i.etsystatic.com/64439944/r/il/15f713/7926881309/il_fullxfull.7926881309_o2t3.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Crystal Ceiling Fan with Light, 48-Inch Wood Blades, Remote Control Chandelier Fan",
    "price": 279.99,
    "image": "https://i.etsystatic.com/64439944/r/il/343d45/7878106752/il_fullxfull.7878106752_ovzp.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Flush Mount Ceiling Fan with Light, 20-Inch Black LED Dimmable, Remote App Control",
    "price": 209.99,
    "image": "https://i.etsystatic.com/64439944/r/il/aacfb4/7878063096/il_fullxfull.7878063096_rk37.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Gold Linear Pendant Light, 47 Inch Dimmable Chandelier for Dining Room",
    "price": 249.99,
    "image": "https://i.etsystatic.com/64439944/r/il/4ad245/7917905495/il_fullxfull.7917905495_2cmn.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Flower Flush Mount Ceiling Fan with Dimmable LED Light, Remote App Control",
    "price": 104.99,
    "image": "https://i.etsystatic.com/64439944/r/il/274896/7917815371/il_fullxfull.7917815371_gm3u.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Mini Square Crystal Chandelier Flush Mount Light, Chrome K9 Crystal Fixture (7.9 Inch)",
    "price": 199.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f3b1a5/7869803258/il_fullxfull.7869803258_kbjn.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Gold Crystal Chandelier Flush Mount Ceiling Light, 5 Tier Raindrop Design (11.8 Inch)",
    "price": 219.99,
    "image": "https://i.etsystatic.com/64439944/r/il/37842d/7869680734/il_fullxfull.7869680734_qbyi.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern 3-Ring LED Chandelier, Black Circular Pendant Light, Warm White Ambiance",
    "price": 249.99,
    "image": "https://i.etsystatic.com/64439944/r/il/b8eacf/7906450783/il_fullxfull.7906450783_qsg4.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal Chandelier Pendant Light: 4-Ring LED, Adjustable Height, Warm White",
    "price": 310,
    "image": "https://i.etsystatic.com/64439944/r/il/d50780/7906423633/il_fullxfull.7906423633_6jcm.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal Flush Mount Ceiling Light, Dimmable LED Chandelier with Remote Control",
    "price": 309.99,
    "image": "https://i.etsystatic.com/64439944/r/il/8b709c/7906395273/il_fullxfull.7906395273_ewke.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black LED Semi Flush Mount Ceiling Light, Adjustable Arms, 3 Color Temperatures",
    "price": 249.99,
    "image": "https://i.etsystatic.com/64439944/r/il/cf92d9/7900450753/il_fullxfull.7900450753_9xh4.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Flexible LED Linear Pendant Light: Dimmable, Adjustable Color Temperature Chandelier",
    "price": 219.99,
    "image": "https://i.etsystatic.com/64439944/r/il/d43ab2/7900438115/il_fullxfull.7900438115_f4qk.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Square LED Ceiling Light, 26 Inch Flush Mount, Dimmable Remote Control",
    "price": 244.99,
    "image": "https://i.etsystatic.com/64439944/r/il/489c52/7900396701/il_fullxfull.7900396701_f22u.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Acrylic LED Chandelier, Dimmable Pendant Light with Remote (3000K-6000K)",
    "price": 199.99,
    "image": "https://i.etsystatic.com/64439944/r/il/5fd617/7898766669/il_fullxfull.7898766669_4dmv.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Linear LED Pendant Light, 39 Inch Woodgrain Finish, Dimmable Hanging Lamp",
    "price": 199.99,
    "image": "https://i.etsystatic.com/64439944/r/il/fca840/7897229773/il_fullxfull.7897229773_3rnf.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Spiral LED Pendant Light, Adjustable Black Hanging Ceiling Lamp (6000K White)",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/1b8f99/7849239956/il_fullxfull.7849239956_mqya.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern LED Linear Pendant Light, 39 Inch Dimmable Chandelier (3000K-6000K)",
    "price": 299.99,
    "image": "https://i.etsystatic.com/64439944/r/il/41b0e8/7845218092/il_fullxfull.7845218092_iq3j.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Chrome Curved LED Flush Mount Light – 6000K White Acrylic Lamp",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/dbd48d/7892958429/il_fullxfull.7892958429_28a4.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Sputnik 4-Light Semi Flush Mount Ceiling Light, Matte Black Metal Fixture",
    "price": 129.99,
    "image": "https://i.etsystatic.com/64439944/r/il/a822da/7826630942/il_fullxfull.7826630942_s11o.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal Flush Mount Chandelier, Beaded Shade Stainless Steel LED Light",
    "price": 169.99,
    "image": "https://i.etsystatic.com/64439944/r/il/658a45/7815189548/il_fullxfull.7815189548_tmp3.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Crystal Flush Mount Ceiling Light Fixture – 3 Ring Stainless Steel Chandelier",
    "price": 179.99,
    "image": "https://i.etsystatic.com/64439944/r/il/68e2d4/7866785548/il_fullxfull.7866785548_ilom.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Eucalyptus Wood Plant Stand with Grow Light, Multi-Tier Indoor Garden Shelf",
    "price": 129.99,
    "image": "https://i.etsystatic.com/64439944/r/il/c0a41a/7715868706/il_fullxfull.7715868706_4zbj.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Set 2 Wooden Shelf Floor Lamps with Linen Shade, 63 Inch Corner Display Light",
    "price": 199.99,
    "image": "https://i.etsystatic.com/64439944/r/il/cceae2/7805234592/il_fullxfull.7805234592_bydt.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Iron Floor Lamp with Shelves, Linen Shade, 3-Color LED Bulb",
    "price": 169.99,
    "image": "https://i.etsystatic.com/64439944/r/il/602e0c/7853147515/il_fullxfull.7853147515_et9p.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Retro Farmhouse Resin Table Lamps Set of 2, Wood Grain Diamond Base, Linen Shade",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/d892cb/7853119917/il_fullxfull.7853119917_4puq.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Set of 2 Coastal Ceramic Table Lamps with Beige Linen Shade (22 Inch)",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/b97366/7798301204/il_fullxfull.7798301204_hek0.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Set of 2 Wood Table Lamps with Beige Linen Shade, 3 Color Temperature Nightstand Lamps",
    "price": 134.99,
    "image": "https://i.etsystatic.com/64439944/r/il/189223/7798250436/il_fullxfull.7798250436_rbfe.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Set of 2 White Ceramic Candlestick Table Lamps with Linen Shades – 20 Inch Bedside",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/82d1c7/7798213896/il_fullxfull.7798213896_mo4i.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Foldable LED Desk Lamp: Rechargeable, Portable, 9 Brightness Levels (White)",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/457edb/7846120823/il_fullxfull.7846120823_5ips.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Small Touch Bedside Lamp: White Frosted Glass Shade, 3-Level Dimmable LED Nightstand Light",
    "price": 104.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f97150/7794554060/il_fullxfull.7794554060_1srp.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "White Ceramic Table Lamp with Fabric Shade, 3 Color Temperature Reading Light",
    "price": 104.99,
    "image": "https://i.etsystatic.com/64439944/r/il/533d86/7842458727/il_fullxfull.7842458727_6zzt.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Set of 2 White Textured Base Table Lamps with Fabric Shade (11.8 Inch)",
    "price": 124.99,
    "image": "https://i.etsystatic.com/64439944/r/il/010131/7794431066/il_fullxfull.7794431066_pq8d.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "LED Desk Lamp with USB Ports, Touch Control, 3 Color Modes, Stepless Dimming",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/7b0c2d/7787091496/il_fullxfull.7787091496_h14w.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Gold Geometric Metal Table Lamp with White Fabric Shade – Modern Bedside Nightstand Desk Lamp",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/7ae23f/7787063204/il_fullxfull.7787063204_3v7t.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Set of 2 Modern White Ceramic Table Lamps with Linen Shade (20.5 Inch)",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/25a5d2/7782777540/il_fullxfull.7782777540_btr5.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Rechargeable Cordless Table Lamp: Silver Aluminum, Touch Control, 3 Color Modes",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/a3426b/7827385911/il_fullxfull.7827385911_rkfg.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Rechargeable Gold Cordless Table Lamp, Stepless Dimming, 3 Color Temperatures (IP44)",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/be733e/7827375285/il_fullxfull.7827375285_oyoq.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Bronze Arc Floor Lamp with Adjustable LED Light, Foot Switch Fabric Shade",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f4e593/7773388676/il_fullxfull.7773388676_pupb.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Boho Rattan Floor Lamp with Side Table, Rustic Gold Farmhouse Lighting",
    "price": 199.99,
    "image": "https://i.etsystatic.com/64439944/r/il/91e7c3/7773311682/il_fullxfull.7773311682_kizq.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Metal Cordless LED Table Lamp: Stepless Dimming, Rechargeable Nightstand Light",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/a0e838/7817887307/il_fullxfull.7817887307_f88c.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Floor Lamp: 60-Inch Black Metal, Oatmeal Linen Shade, 3-Color LED Bulb (Foot Switch)",
    "price": 114.99,
    "image": "https://i.etsystatic.com/64439944/r/il/73d42c/7817848105/il_fullxfull.7817848105_nvg9.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Industrial Farmhouse Floor Lamp, 69 Inch Black Metal Tree Light, Stepless Dimmable Edison Bulbs",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/54ffc3/7769711936/il_fullxfull.7769711936_gzxt.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Arc Floor Lamp with Rattan and Fabric Shades, 63 Inch Black Metal Standing Light",
    "price": 144.99,
    "image": "https://i.etsystatic.com/64439944/r/il/515f0c/7769679968/il_fullxfull.7769679968_mhf8.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Magnetic LED Night Light Cube: 4 Inch Acrylic Lamp, Rechargeable, Adjustable Brightness",
    "price": 105.99,
    "image": "https://i.etsystatic.com/64439944/r/il/a9bbbd/7765580272/il_fullxfull.7765580272_syuy.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "3D Moon Lamp, 6 Inch LED Night Light, 128 Colors, Wooden Stand, Remote Control Decor",
    "price": 89.99,
    "image": "https://i.etsystatic.com/64439944/r/il/e46fdf/7813508565/il_fullxfull.7813508565_h04r.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Bedside Lamp with Qi Wireless Charger, Dimmable LED Nightstand Light",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/fe8563/7811039901/il_fullxfull.7811039901_1u17.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Wood LED Table Lamp: Dimmable Bedside Night Light USB Powered",
    "price": 129.99,
    "image": "https://i.etsystatic.com/64439944/r/il/e2f00d/7810928467/il_fullxfull.7810928467_8ej8.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Wood Square LED Table Lamp: Stepless Dimmable Nightstand Light",
    "price": 89.99,
    "image": "https://i.etsystatic.com/64439944/r/il/155dc2/7755743734/il_fullxfull.7755743734_mpn6.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Minimalist LED Table Lamp: Cordless, Rechargeable, Dark Gray Nightstand Light",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/4bb5b0/7803671069/il_fullxfull.7803671069_8rc1.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Beech Wood LED Night Light: Dimmable Warm Glow Bedside Lamp",
    "price": 84.99,
    "image": "https://i.etsystatic.com/64439944/r/il/40894c/7801069017/il_fullxfull.7801069017_sur8.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Dual Frame LED Table Lamps (Set of 2), Black Gold, Stepless Dimmable Lights",
    "price": 169.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f83b54/7753089132/il_fullxfull.7753089132_p5s6.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern White Circle LED Table Lamp: Stepless Dimming, 3 Color Temperatures",
    "price": 149.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f8508c/7753065118/il_fullxfull.7753065118_bilo.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Small Wood Table Lamp with Linen Shade – Modern Nightstand Light",
    "price": 114.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f7b7ae/7753045376/il_fullxfull.7753045376_1sse.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Wood LED Desk Lamp, Minimalist Ellipse Bedside Night Light, USB Table Lamp",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/8ccfa0/7753011052/il_fullxfull.7753011052_ojtn.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Black Metal Floor Lamp, Beige Linen Shade, Adjustable Color Temperatures",
    "price": 119.99,
    "image": "https://i.etsystatic.com/64439944/r/il/37bf43/7770727771/il_fullxfull.7770727771_b99e.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Oval LED Table Lamp, Wood Base, 3 Color Temperatures, Touch Dimming",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/49c637/7797576615/il_fullxfull.7797576615_9pt0.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Small Wood Tripod Table Lamp, Minimalist Boho Bedside Nightstand Light",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/50ba6f/7749592950/il_fullxfull.7749592950_a2j4.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Boho Farmhouse Table Lamp, Wood Grain Metal Base, Beige Linen Shade, 21.85 Inch",
    "price": 99.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f58c3b/7749565494/il_fullxfull.7749565494_kdfc.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Spiral LED Table Lamp: Black, Stepless Dimmable Bedside Light",
    "price": 134.99,
    "image": "https://i.etsystatic.com/64439944/r/il/6426aa/7793993855/il_fullxfull.7793993855_j31w.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Wood Tripod Table Lamp, Linen Beige Shade, Bohemian Bedside Nightstand Light",
    "price": 114.99,
    "image": "https://i.etsystatic.com/64439944/r/il/dbbf50/7793913667/il_fullxfull.7793913667_srpy.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Handwoven Rattan Table Lamp, Bohemian Wood Triangular Base, Bedside Nightstand Light",
    "price": 124.99,
    "image": "https://i.etsystatic.com/64439944/r/il/887c0f/7745932128/il_fullxfull.7745932128_jdhv.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Small Wood Base Lamp, Beige Linen Shade, Warm White Nightstand Light, Boho Desk Lamp",
    "price": 84.99,
    "image": "https://i.etsystatic.com/64439944/r/il/0b717d/7790032577/il_fullxfull.7790032577_1mnl.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Small Minimalist Table Lamp, Cream Linen Shade, Black Base Bedside Nightstand Light",
    "price": 69.99,
    "image": "https://i.etsystatic.com/64439944/r/il/fa556b/7742031746/il_fullxfull.7742031746_pix3.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Torchiere Floor Lamp: Tall Upward Lighting, White Shade, 71.5 Inch",
    "price": 91.99,
    "image": "https://i.etsystatic.com/64439944/r/il/f8230b/7741983244/il_fullxfull.7741983244_631i.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern White Linen Floor Lamp – Tall Slim Minimalist Home Decor, Foot Switch",
    "price": 94.99,
    "image": "https://i.etsystatic.com/64439944/r/il/4929c1/7789892851/il_fullxfull.7789892851_niye.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Vintage Style Candle Warmer Lamp, Adjustable Height Wax Melt Warmer, Timer Dimmer",
    "price": 104.99,
    "image": "https://i.etsystatic.com/64439944/r/il/fa2ebf/7786507151/il_fullxfull.7786507151_k42q.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Floor Lamp with White Linen Shade, 60 Inch Tall Standing Lamp",
    "price": 104.99,
    "image": "https://i.etsystatic.com/64439944/r/il/63ec5e/7731878876/il_fullxfull.7731878876_aszs.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Black Metal Candle Warmer Lamp with Adjustable Height and Timer Function",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/941001/7731845996/il_fullxfull.7731845996_i9rs.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Matte Black Ceramic Bottle Vase, Rustic Farmhouse Boho Home Decor",
    "price": 89.99,
    "image": "https://i.etsystatic.com/64439944/r/il/aa1aef/7777019279/il_fullxfull.7777019279_gh3y.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Black Geometric Ceramic Vase: Modern Farmhouse Table Decor",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/c4789b/7775938873/il_fullxfull.7775938873_hzfj.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Gold Mirror LED Digital Alarm Clock, Dual USB Charger",
    "price": 92.99,
    "image": "https://i.etsystatic.com/64439944/r/il/545e65/7722862168/il_fullxfull.7722862168_6k53.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Black Honeycomb Metal Floor Vase Set, Modern Home Decor",
    "price": 134.99,
    "image": "https://i.etsystatic.com/64439944/r/il/d92ef8/7770664169/il_fullxfull.7770664169_1zjj.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Tall Black Twisted Ceramic Vase - Modern Geometric Home Decor",
    "price": 104.99,
    "image": "https://i.etsystatic.com/64439944/r/il/913a3d/7770111857/il_fullxfull.7770111857_7x4u.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Modern Black Floor Lamp with Shelves, 3-Color LED Bulb",
    "price": 115.99,
    "image": "https://i.etsystatic.com/64439944/r/il/ac07c6/7719627020/il_fullxfull.7719627020_bauj.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Oak Mountain and Sun Wooden Wall Art - Modern Sculpture Set of 3",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/6b50d3/7767541365/il_fullxfull.7767541365_dymn.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Rustic Brown Floor Lamp Table with Shelves & 3-Color LED",
    "price": 129.99,
    "image": "https://i.etsystatic.com/64439944/r/il/4b1d3c/7767496979/il_fullxfull.7767496979_eb7g.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Gold Metal Female Body Line Art Set - Modern Minimalist Wall Sculpture",
    "price": 109.99,
    "image": "https://i.etsystatic.com/64439944/r/il/440726/7719511072/il_fullxfull.7719511072_lrvr.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Beige Resin Reading Thinker Statue - Modern Art Deco Figurine",
    "price": 79.99,
    "image": "https://i.etsystatic.com/64439944/r/il/8f11a7/7763914167/il_fullxfull.7763914167_uhqs.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Ceramic Easter Bunny Set: White & Gold Farmhouse Decor",
    "price": 98.99,
    "image": "https://i.etsystatic.com/64439944/r/il/bc16a7/7763886213/il_fullxfull.7763886213_rmec.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Art Deco Thinker Statue Set, Black and Gold Resin Figurines",
    "price": 99.99,
    "image": "https://i.etsystatic.com/64439944/r/il/8b3260/7715918246/il_fullxfull.7715918246_cmr4.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Abstract Kissing Lovers Sandstone Sculpture, Modern Home Decor",
    "price": 69.99,
    "image": "https://i.etsystatic.com/64439944/r/il/6de299/7706869308/il_fullxfull.7706869308_m677.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "Abstract Hugging Couple Sculpture: Modern White Resin Statue, Anniversary Gift",
    "price": 79.99,
    "image": "https://i.etsystatic.com/64439944/r/il/c131bd/7706771202/il_fullxfull.7706771202_agdt.jpg",
    "listingUrl": "https://www.etsy.com/shop/square18newyork",
    "marketplace": "etsy",
    "freeShipping": true
  },
  {
    "name": "( Pack of 2 ) New Great Value Fig bars Family size 32 Oz Each.....",
    "price": 11.68,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887916399",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "(2 pack) Club Snack Stacks Original Crackers, Lunch Snacks, 9 Count",
    "price": 10,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887957861",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "(3 pack) Great Value Creme Filled Swiss Rolls Snack Cakes, 13 oz, 6 Count",
    "price": 8.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885957144",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "(3 pack) Juan Valdez Instant Coffee, Classic Freeze Dried, 3.52 Oz",
    "price": 24.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886082450",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "(4 pack) Great Value Light Brown Sugar, 32 oz, Free Shipping...",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880201689",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "⭐ PLANTERS Deluxe Honey Roasted Whole Cashews 8.25 oz – Sweet & Salty Snack – Pl",
    "price": 7.4,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887994090",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "1 Pack Egyptian Magic All Purpose Skin Cream 4oz FREE SHIPPING",
    "price": 12.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874333171",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "1 Pc Stainless Steel Peeler with Wooden Handle – Fruit & Vegetable Slicer",
    "price": 6.29,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901995239",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "1 Pcs Gas Fuel Sync Farther,Save More Fuel Instantly,Automotive Spill Save,New",
    "price": 11.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856581246",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "10 Pcs 3D Dragonfly Garden Decor Dragon Fly Garden Stakes Dragonflies Garden 10X",
    "price": 5.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902002361",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "100 Car Winter Windshield Washer Wiper Fluid Concentrated Tablets Glass Cleaner*",
    "price": 9.15,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902005073",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "100pcs Double-Wire Plug-in Connector, Cable Clamp with Locking Buckle, AWG 18-22",
    "price": 7,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856580953",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "10cm Resident Evil Leon S. Kennedy Plush Toy Soft Stuffed Keychain Gift",
    "price": 13.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874775431",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "10Pack Quick Solderless Wire Splice Connector, 2 Way Automotive Fits 18-24 AWG",
    "price": 8.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910723636",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "16 Rabbit Pillow Plush Toy, Miffy Sweet Doll Cushion, Cute Gift for Kids & Fans",
    "price": 19.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902005410",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "2 Pieces 25 Inch Silicone Stove Gap Filler Kitchen Counter Top Gap Cover",
    "price": 7,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857145803",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "2.4GHz Wireless Optical Mouse USB Rechargeable RGB Cordless Mice For PC Laptop",
    "price": 8.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910637048",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "2026 Cute Dandy’s World Gourdy Plush Toy Pumpkin Stuffed Doll Holiday Gift",
    "price": 20.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857146661",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "21pcs Stainless Steel Key Practice Set – Professional Door Unlocking Tools",
    "price": 15.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857143447",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "24/144 Style Pokemon Figure Toys Anime Pikachu Action Figure Mini Doll Kids Toy",
    "price": 11.64,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859026135",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "26cm Dandy’s World Plush Doll Bassie Plush Stuffed Toy Pillow Kids Gift Birthday",
    "price": 14.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856613553",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "2PCS Tactical Metal Hook Elastic Belt Buckle-Less Invisible Waist Belt Closure",
    "price": 8.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894475025",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "3/5/6 Tier Bamboo Shoe Rack Organizer Wooden Shelf Entryway Space Saving",
    "price": 35.89,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901997469",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "30CM IKEA AFTONSPARV Alien Plush - Green Kids' Favorite 13 ½ Soft Toy Anime NEW",
    "price": 8.55,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901994118",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "30CM Large Anime My Neighbor TOTORO Plush Toy soft Stuffed Doll for Kids - NEW",
    "price": 20.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894477923",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "9 XXXTentacion Inspired Plush Toy, Music Tribute Doll Collectible Gift",
    "price": 20.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894497752",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "AC1200 WiFi 5 PCIE WiFi Adapter Wireless Network Card",
    "price": 11.79,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902008809",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Antler Shed Hunting & Mushroom Finding  Blue Hunting Finder Glasses US**",
    "price": 6.24,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910461000",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Apexdrive Drive Pro for Men Multiple Modes Therapy Device Rechargeable Gifts",
    "price": 22.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859027896",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Apexdrive Drive Pro for Men Multiple Modes Therapy Device Rechargeable Gifts",
    "price": 22.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859063785",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Apexdrive Pro for Men, Multiple Modes Rechargeable Therapy Device",
    "price": 18.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856580411",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Arizona Green Tea with Ginseng and Honey, 11.5 Fl Oz Cans (12-Pack)",
    "price": 5.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886052293",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Battery Powered Electric Fuel Transfer Siphon Pump Gas Oil Water Liquid 2.2 GPM",
    "price": 10.55,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902007519",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Besque Magic Luxury Body Oil 3.4 oz Firms Tighten & Hydrate Loose Skin Pump",
    "price": 14.92,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306870499198",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Black AF History: The Un Whitewashed Story of America by Michael Harriot A5-Size",
    "price": 15,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902006877",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Book of Wisdom Volumes 1 by Harry B. Joseph",
    "price": 14.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894512451",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Braided Solo Loop Band Strap for Apple Watch 9 8 7 6 5 4 SE 40 44 41 45mm",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910715734",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Bunny Lulu Keychain with Tin",
    "price": 14.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306870529296",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "BX Ripcord String Launcher for Bey X Burst Gyro Beyblade Toy Battle Accessory",
    "price": 8.49,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874748026",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Cap'n Crunch's Crunch Berries, Mega Bag, 40 Oz Free & Fastt Shipping......",
    "price": 7.18,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886233330",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Car Phone Holder Air Vent Mount 360° Rotation Universal iPhone GPS",
    "price": 4.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874734547",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Cascadian Farm Organic Granola, Oats and Honey Cereal, Resealable Pouch, 11 Oz.",
    "price": 4.56,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886087888",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Chex Mix Bold Garlic and Herb Snack Mix, Snack Tub, 20 oz",
    "price": 8.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887914222",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Chex Mix Cheddar Savory Snack Mix Salty Snacks Tub 20 oz",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885917393",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Chicken in a Biskit Original Baked Crackers, Family Size Snack, 12 oz",
    "price": 5.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885975136",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Chip Seagull Fun Stuffed Ocean Sea Bird  Soft Plush Toy Gift NWT",
    "price": 19.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894479342",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "CHIPS AHOY! Chewy Chocolate Chip Cookies, Party Size, 26 oz",
    "price": 4.29,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884205378",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Coach Glitter Cherry Bag Charm Keychain Resin and Metal Brass/Red Apple NWT🎀",
    "price": 28.88,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902004017",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Cocoa Puffs Chocolate Breakfast Cereal with Whole Grains Family Size 25.8 oz",
    "price": 5.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886197244",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Cookie Crisp Breakfast Cereal Family Size 18.3 Oz Chocolate Chip Cookie Taste",
    "price": 4.98,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887941232",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Couples Support Pillow Memory Foam Cushion for Intimacy Comfort & Back Support",
    "price": 43.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859065601",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Disney Pixar Cars Lighting McQueen Crocs Men/Women Multiple Sizes No LightUp",
    "price": 35.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859064474",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Dog Chew Toys for Aggressive Chewers,Indestructible Tough Durable Squeaky DogToy",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894508659",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Dr Pepper & Cream Soda Pop, 12 fl oz, 12 Pack Cans",
    "price": 8.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885855672",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Dr Pepper Soda Pop, 12 fl oz, 12 Pack Cans",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880194227",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Dust Plug Type-c USB Charging Port Protector Silicone Cover For Smart 6pcs",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910619906",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Famous Amos Classic Chocolate Chip Cookies,Bite-size cookies,10 Pack Box,1oz Bag",
    "price": 5.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886036758",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Fiber Bird Nesting Heart, Birds Nests Material Holder, Hummingbird Nest Boxes",
    "price": 14.2,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306872692853",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "FNAF Five Nights At Freddy's Plush Toy SpringTrap FUNKO Stuffed Dolls Toy Gifts",
    "price": 9.2,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874336180",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "For iPhone 17 16 15 14 13 Original Leather Wallet Card Holder Case With MagSafe",
    "price": 13.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856580755",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "For iPhone 17/ 16/15/14/13 Tempered Glass Camera Len Protector Bling Diamond",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910536887",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "For Samsung Galaxy S25 Ultra S24 S23 S22 Frosted Case Mag Safe Shockproof Cover",
    "price": 11.64,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857136266",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "French Vanilla Medium Roast Ground Coffee, 12 oz, Bag",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880360491",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Frito-Lay Family Fun Mix Variety Pack Snack Chips, 18 Count Multipack New",
    "price": 8.47,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885934200",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Fruit Roll-Ups, Fruit by the Foot, Gushers, Snacks Variety Pack, 16 Ct, 10.2 oz",
    "price": 4.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886094491",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Full Denture Set For Men And Women Upper And Lower Denture False Teeth Personal",
    "price": 14.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874731790",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "FUNKO Five Nights At Freddy's FNAF Plush 6 Bonnie, Freddy, Chica, Foxy NEW",
    "price": 10.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306872601292",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Gabby’s Dollhouse 10 Plush Pillow Cat Purr-ific Stuffed Animals Plushie Dolls",
    "price": 12.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859026331",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Gatorade Frost Thirst Quencher Glacier Cherry Sports Drinks, 12 fl oz, 12 Count",
    "price": 7,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884208744",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Gatorade Zero Sugar Thirst Quencher Orange Sports Drinks, 12 fl oz, 12 Count Bot",
    "price": 7.65,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884195784",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Genuine Calfskin Leather Watch Band 18mm 20mm 22mm 24mm Butterfly Buckle Strap",
    "price": 10.88,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901996902",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "German Intelligent Color Progressive Auto Focus Reading Glasses See More Clearly",
    "price": 9.7,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857144811",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "GHOST PROTEIN CEREAL, LUCKY CHARMS Flavor, 17G Protein, 9.4 oz...",
    "price": 8.25,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885928983",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Cream Soda Pop, 12 fl oz, 12 Pack Cans",
    "price": 5.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880181335",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Creamy Peanut Butter, Spread, 64 oz - Free Shipping",
    "price": 6.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885909595",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Dr Thunder Diet Calorie free Cola Soda Pop, 12 fl Oz 24 Pack Cans...",
    "price": 11.49,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886069870",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Easy Melt Cheese Block, 32 oz",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880210268",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Frosted Mini Donuts, 10 Oz",
    "price": 4.95,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886118540",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Grated Parmesan Cheese, 16 oz Bottle",
    "price": 6.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887981877",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Great Value Purified Drinking Water, 16.9 Fl. Oz., 40 Count",
    "price": 6.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885892175",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Green Duolingo Owl Plush Toys Duo Plushie Of Duo The Owl Cartoon Anime Owl Doll",
    "price": 11.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894519557",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Hand Pump Oiler Can Professional Level 8oz Capacity with Metal Long Flex Spout",
    "price": 11.89,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894472132",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Health Garden Real Birch Xylitol All Natural Sweetener, 1.0 LB.",
    "price": 10.44,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887984871",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Hidden Suspenders Adjustable Under The Shirt Suspenders for Men Fashion",
    "price": 6.74,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306870480761",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "High-end Alloy Metal Compressor Presser Shaped Mini Tobacco Herb Press Squeezer",
    "price": 15.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859064810",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Homer Disappearing into Bush Meme – 227PCS Simpsons Building Block Set Funny Toy",
    "price": 19.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857139979",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Honda Japanese Kei Truck MOC Technic Building Block Model Toy Car 348pcs Gift",
    "price": 21.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856580452",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "HONEY MAID Graham Crackers, Lunch Snacks, Family Size, 19.2 oz",
    "price": 5.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886009414",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "iondrops Filtered Shower Head with Handheld,High Pressure Showerhead w...",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902007961",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Jelly cat Amuseables Steepy Tea Bag EXCLUSIVE Brand New -Free Shipping 🚚 NO TAG",
    "price": 29.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902005764",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Jellycat AMUSEABLE CROISSANT BAG CHARM Soft AUTHENTIC Plush Not  Dust Bag NO TAG",
    "price": 20.02,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894501782",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "JOLLY TIME Simply Popped Natural Microwave Popcorn, Non-GMO - 24 Ct",
    "price": 10.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880151336",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Kasane Teto Nuipurike Osuwari Plush Doll Mascot Toy Gift Collectible 25cm",
    "price": 18.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910514451",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Kawaii Stitch Sleep Plush Toy - Calm Music, Lights & Breathing Effect Kids Gift",
    "price": 19.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902006156",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "KB SpongeBob Card Mystery Box – 36 Packs Sealed Trading Cards Collectible",
    "price": 22.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901985783",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "KB SpongeBob Card Mystery Box – 36 Packs Sealed Trading Cards Collectible",
    "price": 16.8,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902003522",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "KB SpongeBob Squarepants VOL.1 Collection Trading Card Sealed Booster Box",
    "price": 26.78,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902003061",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Kellogg's Frosted Krispies Breakfast Cereal, Kids Snacks, Family Breakfast,",
    "price": 5.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885993861",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Kellogg's Raisin Bran Crunch Breakfast Cereal, Good Source of Fiber, Mega",
    "price": 6.8,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884202309",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Kraft Cheez Whiz Original Cheese Dip, 15 oz Jar",
    "price": 5.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886240972",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Kraft Grated Parmesan Cheese Shaker 16 oz Bottle",
    "price": 7.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887944666",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Lance sandwich crackers, variety pack, 3 Flavors, 20 Individually Wrapped Packs.",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880198705",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Lipton Lemon Iced Tea Mix, Caffeinated, Black Tea, 28 Quarts",
    "price": 8.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887922077",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Little Debbie Big Pack Nuddy Buddy Wafer Bars, 24.1 oz (24 count)",
    "price": 6.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880096591",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Little Debbie Big Pack Oatmeal Crème Pies, 30 oz (12 count)",
    "price": 5.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880092555",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Little Debbie Swiss Rolls - 13oz Creamy Chocolate Cakes Perfect for Snacking",
    "price": 4.85,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886100558",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Little Hug Fruit Barrels Variety Pack Kids Drinks 20x8oz Low Sugar",
    "price": 4.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886107231",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "M&M's Honey Roasted Peanut Chocolate Candy 9.0oz",
    "price": 6.1,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885897450",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Mac's Chicharrones Golden Cracklin Curls, Fried Pork Fat with Skin, 12 oz Bag.",
    "price": 6.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884209501",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Magnetic Phone Case For iPhone 17 16 15 14 13 12 Pro Max Plus Bumper Hard Cover",
    "price": 12.79,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859025868",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Mars Mixed Snickers, Twix, Milky Way 3 Musketeers Minis Chocolate Bars 19.49 oz",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887925679",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Men's Slide Slippers EVA Indoor Outdoor Comfort Casual Shoes Sandals Gym Gift",
    "price": 12.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306870559679",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Micro HDMI to HDMI Cable Adapter Converter 4K GoPro HERO 7 6 Camera 60Hz",
    "price": 5.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306859065309",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Miniso Stitch Eat Something Before Sleep Series Vinyl Figure Confirmed Blind Box",
    "price": 9.98,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902004762",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Nabisco Cookie Variety Pack, , Nutter Butter, CHIPS AHOY!, 10 Snack Packs (4 Coo",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887968064",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Nee Doh Ice Cream Nice-Sicle Squeezable Stress Reliever Sensory Toy",
    "price": 16.86,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910386436",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "NeeDoh Jelly Squish Stress Toy Jellyfish Fidget Sensory Squeeze Toy Squishy Toy",
    "price": 15.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910361308",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Needoh Limited Edition Dr Pepper Nice Cube Suptid Squish",
    "price": 16,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910323246",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Nestle Milo Active Go Chocolate Malt Powder Drink Mix, 14.1 oz",
    "price": 5.19,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887919347",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "NEW Five Nights At Freddy's 6 Shadow Freddy Bear Plush Dol Toy",
    "price": 9.95,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306856619673",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "NEW Gummy Bear Plush Green Singing Bear Toy Christmas Celebration Props Toys",
    "price": 19.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902006401",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "New Haunter Plush Soft Toy Stuffed Animal Doll Teddy 12 LARGE SIZE Xmas Gift",
    "price": 20.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894497035",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Ocean Spray® 100% juice cranberry  juice Blend, 101.4 fl oz Bottle.... 2 pack",
    "price": 12.4,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887989521",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "One Minute with God for Men by Amy Mason, Katherine Butler and Ronald Beers...",
    "price": 11.55,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901999271",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Orville Redenbacher's Ultimate Butter Microwave Popcorn, 3.29 oz, 12 Count",
    "price": 7.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880046128",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "PACK OF 30 Card Stand Trading Card Stands Baseball Display Stand Holder 3 US",
    "price": 4.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910505736",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Peluche Plim Clown Kawaii – Jouet Doux Anniversaire Pour Enfants US",
    "price": 10.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874341534",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Pepsi Cola Soda Pop, 12 fl oz, 12 Pack Cans",
    "price": 7.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880335022",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Pepsi Prebiotic Cola Soda Pop Cherry Vanilla 8 Pack – 12 fl oz Cans Functional S",
    "price": 7.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880132250",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Premium Mens Brando Classic Leather Jacket Leather Bikers Leather Jacket",
    "price": 53,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874754823",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Propel Black Cherry Water with Electrolytes, Vitamins C,E, 16.9 fl oz Bottles, 1",
    "price": 10.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886024201",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Pure Life Purified Water, 16.9 Fl Oz / 500 mL, Plastic Bottled Water (35 Pack)",
    "price": 6.25,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880329637",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Quaker Chewy Granola Bars, 3 Flavor Variety Pack, 30.4 oz, 36 Count",
    "price": 8.45,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306885812811",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Quaker Instant oatmeal fruit & cream Variety Pack – 20 individual Packets...",
    "price": 5.84,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887997813",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Quaker Simply Granola Cereal Oats Honey Almonds 24.1 oz Ready to Eat",
    "price": 6.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884176631",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Quest Tortilla Style Protein Chips, Chili Lime, 1.1oz - 4 Count Bags",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887979266",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Quest Tortilla Style Protein Chips, Nacho Cheese, Baked, 1.1oz, 4 Count",
    "price": 8.35,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887950820",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Ratatouille Magnetic Doll Toys Cute Kid Plush Doll Shoulder Decoration Room",
    "price": 11.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894468921",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Ratatouille Magnetic Doll Toys Cute Kid Plush Doll Shoulder Decoration Room",
    "price": 9.65,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902003786",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Real Cowhide Insole Leather Shoes Boots Shoe Inserts Soft Breathable Deodorant A",
    "price": 5.25,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902002089",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Reflective Service Dog Vest Harness, Woven Nylon with Adjustable Straps XS-XXL",
    "price": 15.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306901996342",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Rice Krispies Treats Original, 40 Count, 31.2oz Chewy Marshmallow Squares.",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880170179",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "SKIPPY No Sugar Added Creamy peanut butter spread, Shelf-Stable, 40 oz Plastic J",
    "price": 6.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886205582",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Smartfood Popcorn White Cheddar Flavored Popcorn Snacks, 0.625 oz Bags, 10 Count",
    "price": 6.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884185360",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Smartwater Premium Canned Drinking Water, 12 fl. oz. sleek cans, 8-pack",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886151976",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Smucker’s Natural Creamy Peanut Butter, 26 oz Jar",
    "price": 6.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884208002",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Snack Cakes, Little Debbie Big Pack COSMIC ® Brownies",
    "price": 5.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884210464",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Snickers Fun Size Chocolate Candy Bars – 10.59 oz Bag",
    "price": 6.59,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886160204",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Snickers Fun Size Football Chocolate Bars Variety Pack, 24.02 oz Bag",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886129569",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Spin Mop and Bucket with Wringer Set, 360°stainless steel Spinning Mop 4 Refills",
    "price": 39.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306860932676",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Spinning Fishing Reel Cover Neoprene Wheel Protective Waterproof Storage Bag",
    "price": 8.2,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306872710161",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Sprite Lemon Lime Soda Pop, 12 fl oz, 12 Pack Cans..........",
    "price": 8,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306880143939",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Squishy Cheese Block, Stress Relief Squeeze Toy Gifts ,Cyber Deal 🔥",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910557848",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Stainless Steel Apple Cutter Divider Fruit Vegetable Slicer with Comfort Handle",
    "price": 6.4,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902004457",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Sunny Days Squeezy Butter - Tiktok Viral Sensory Stress Relief Squeeze Toy TL",
    "price": 9.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306872659464",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "SUNNYD Blue Raspberry Shelf Stable Juice Drink, 15 Count, 11.3 fl oz Bottles",
    "price": 8.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887931890",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Tampico Citrus Punch Orange Tangerine Lemon Juice Drink 10 Fl Oz 15 PackTampico",
    "price": 5.9,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886220172",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Teen Titans Go Robin Gift Cyborg Beast Boy Kids Toy 5 PCS Action Figure Gift",
    "price": 16.49,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874771551",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "That'S Not a Hat - Fun Bluffing & Memory Party Game for All Ages Components",
    "price": 18.54,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306860932677",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "The Amazing Digital Circus Plush,10 Jax Plushies Toy Gift, Cute Stuffed Figu...",
    "price": 14.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894477074",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "The Muppet Show Swedish Chef Plush Toy Doll 45cm",
    "price": 35,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306902007201",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Toe Separator Bunion Corrector Silicone Straightener Orthopedic Spacer",
    "price": 4.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874790062",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Torani 750 mL Flavoring Syrup 25.4 oz",
    "price": 7.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886063502",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Tostitos Scoops Large Party-Size Tortilla Chips, 14.5-ounce Bag",
    "price": 5.94,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306887935525",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "True Fit Posture Corrector Belt Adjustable Back Brace Straightener For Men Women",
    "price": 9.69,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306910480702",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "USB C to SD Card Reader, 3-in-1 Hub Converter, Micro SD TF Memory Type-C Adapter",
    "price": 8.78,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306860932679",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Wallet Card Holder Case for iPhone 16e 15 14 13 12 11 Pro Max XS Leather Cover",
    "price": 13.94,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306857147636",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Wave Max Tv Antenna 2025, Wave Max Tv Antenna Signal Booster TL",
    "price": 10.99,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306874757352",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Welch's 100% Grape Juice, Concord Grape, 96 fl oz Bottle",
    "price": 7.12,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306886143070",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "Wendy’s Chili With Beans Canned Chili 15 oz Can 29g Protein Per Serving",
    "price": 6.22,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306884206521",
    "marketplace": "ebay",
    "freeShipping": true
  },
  {
    "name": "XD Card Reader Photos Memory Adapter + USB C Converter for Olympus Fuji Cameras#",
    "price": 9.5,
    "image": null,
    "listingUrl": "https://www.ebay.com/itm/306894510951",
    "marketplace": "ebay",
    "freeShipping": true
  }
];

export default products;

export const testimonials = [
  {
    "id": 1,
    "name": "Sarah M.",
    "location": "Brooklyn, NY",
    "rating": 5,
    "text": "Absolutely love the quality of products from Square18! The shipping was fast and everything arrived in perfect condition. Will definitely be ordering again.",
    "avatar": "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
  },
  {
    "id": 2,
    "name": "Michael R.",
    "location": "Manhattan, NY",
    "rating": 5,
    "text": "Found exactly what I was looking for at great prices. The customer service team was incredibly helpful when I had questions about my order.",
    "avatar": "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
  },
  {
    "id": 3,
    "name": "Jennifer L.",
    "location": "Queens, NY",
    "rating": 5,
    "text": "The curated selection is impressive. Every item I've purchased has exceeded my expectations in quality. Square18 is now my go-to online store.",
    "avatar": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop"
  }
];

export const stats = [
  {
    "label": "Products",
    "value": "100+"
  },
  {
    "label": "Happy Customers",
    "value": "10,000+"
  },
  {
    "label": "Brand Partners",
    "value": "50+"
  },
  {
    "label": "Years of Excellence",
    "value": "4+"
  }
];

export const features = [
  {
    "title": "Curated Selection",
    "description": "Hand-picked products from trusted brands and suppliers, ensuring quality in every purchase.",
    "icon": "CheckCircle"
  },
  {
    "title": "Fast Shipping",
    "description": "Quick and reliable delivery across the nation with real-time tracking on all orders.",
    "icon": "Truck"
  },
  {
    "title": "Secure Shopping",
    "description": "Your data is protected with industry-leading security measures and encrypted transactions.",
    "icon": "Shield"
  },
  {
    "title": "Easy Returns",
    "description": "30-day hassle-free return policy. Not satisfied? We'll make it right.",
    "icon": "RefreshCw"
  }
];
